<footer class="app-footer">
  <abook-container width="wide" class="app-footer__inner">
    <!-- ── FooterTop ──────────────────────────────────────────────────── -->
    <div class="app-footer__top">
      <!-- Brand column -->
      <div class="app-footer__brand">
        <a class="app-footer__logo" routerLink="/" aria-label="Gå til forsiden">
          @if (site.settings()?.logo) {
            <img [src]="site.settings()!.logo" alt="Logo" class="app-footer__logo-img" />
          } @else {
            <span class="app-footer__logo-text">{{
              (site.settings()?.name ?? 'Aktiv By').toUpperCase()
            }}</span>
          }
        </a>

        @if (footerConfig().tagline) {
          <p class="app-footer__tagline">{{ footerConfig().tagline }}</p>
        }
      </div>

      <!-- Platform column -->
      <div class="app-footer__col">
        <p class="app-footer__col-heading">
          {{ (site.settings()?.name ?? 'Halnavn').toUpperCase() }}
        </p>
        <nav class="app-footer__col-nav" aria-label="Om os">
          <a routerLink="/practical">Ofte stillede spørgsmål</a>
          <a routerLink="/contact">Kontakt</a>
        </nav>
      </div>

      <!-- Legal column -->
      <div class="app-footer__col">
        <p class="app-footer__col-heading">Juridisk</p>
        <nav class="app-footer__col-nav" aria-label="Juridisk">
          @for (link of legalLinks(); track link.key) {
            @if (link.href) {
              <a [href]="link.href">{{ link.label }}</a>
            } @else {
              <a [routerLink]="link.route">{{ link.label }}</a>
            }
          }
        </nav>
      </div>

      <!-- Connect column: only what the tenant has configured -->
      @if (showThirdColumn()) {
        <div class="app-footer__col app-footer__col--third">
          @if (hasSocial()) {
            <p class="app-footer__col-heading">Følg os</p>

            <div class="app-footer__social" role="list" aria-label="Sociale medier">
              @for (link of socialLinks(); track link.key) {
                <a
                  class="app-footer__social-btn"
                  [href]="link.url"
                  [attr.aria-label]="link.label"
                  role="listitem"
                  target="_blank"
                  rel="noopener"
                >
                  <svg viewBox="0 0 18 18" aria-hidden="true" fill="currentColor">
                    <path [attr.d]="link.path" />
                  </svg>
                </a>
              }
              @if (contact().email; as email) {
                <a
                  class="app-footer__social-btn"
                  [href]="'mailto:' + email"
                  aria-label="E-mail"
                  role="listitem"
                >
                  <mat-icon aria-hidden="true">mail</mat-icon>
                </a>
              }
            </div>
          }

          @if (hasContact()) {
            <p class="app-footer__col-subheading">Kundeservice:</p>
            <address class="app-footer__contact">
              @if (contact().address; as address) {
                <span class="app-footer__contact-line">
                  <mat-icon aria-hidden="true">location_on</mat-icon>
                  <span>{{ address }}</span>
                </span>
              }
              @if (contact().email; as email) {
                <a class="app-footer__contact-line" [href]="'mailto:' + email">
                  <mat-icon aria-hidden="true">mail</mat-icon>
                  <span>{{ email }}</span>
                </a>
              }
              @if (contact().phone; as phone) {
                <a class="app-footer__contact-line" [href]="phoneHref()">
                  <mat-icon aria-hidden="true">phone</mat-icon>
                  <span>{{ phone }}</span>
                </a>
              }
            </address>
          }
        </div>
      }
    </div>

    <!-- ── Divider ────────────────────────────────────────────────────── -->
    <div class="app-footer__divider" aria-hidden="true"></div>

    <!-- ── FooterBottom ───────────────────────────────────────────────── -->
    <div class="app-footer__bottom">
      <p class="app-footer__copyright">© {{ currentYear }} {{ site.settings()?.name }}</p>
      <p class="app-footer__brand-credit">A-book</p>
    </div>
  </abook-container>
</footer>
